import loadable from '@loadable/component';

export const GradFairInviteContainerLoadable = loadable(
  () => import('./GradFairInviteContainer'),
  {
    resolveComponent: (module) => module.GradFairInviteContainer,
  },
);
